import React, { useState, useMemo, useEffect } from "react";
// react plugin used to create DropdownMenu for selecting items
import Select from 'react-select'
import './SelectInstitution.css'
import { studentBoundList, getCredentials } from "../../../../network/ApiAxios";
import secureLocalStorage from "react-secure-storage";

const SelectInstitution = (props) => {
  const [value, setValue] = useState()
  const [options, setOptions] = useState([])
  const group = props.group
  const setGroup = props.setGroup
  const setTeachersOptions = props.setTeachersOptions
  const setStudentsOptions = props.setStudentsOptions
  const setShowStudents = props.setShowStudents
  const setShowTeachers = props.setShowTeachers
  const user = JSON.parse(secureLocalStorage.getItem("user"));
  const app = JSON.parse(secureLocalStorage.getItem("app"));

  const loadTeachers = async () => {

    //mostra Spinner enquanto busca Teachers
    setShowTeachers(false)

    let params = {
      filter: {
        institution: group.institution
      },
      constraint: {
        user: { account: user.account },
        type: { isOwner: false }
      }
    }

    const response = await getCredentials(params);
    const { data } = response;

    if (data.success) {
      setTeachersOptions(data.credentials)
      //desliga o Spinner quando encontra Teachers
      setShowTeachers(true)
    }
  }

  const loadStudents = async () => {
    //mostra Spinner enquanto busca Students
    setShowStudents(false)

    let params = {
      filter: { 
        account: user.account, 
        institution: group.institution,
      },      
      constraint: {
        isBound: true,
        app: app._id, installation: { active : true }
      }
    }

    const response = await studentBoundList(params);
    const { data } = response;

    if (data.success) {
      setStudentsOptions(data.students)
      //desliga o Spinner quando encontra Students
      setShowStudents(true)
    }
  }

  const changeHandler = item => {
    setValue(item)
    group['institution'] = item.value
    setGroup(group)

    loadTeachers()
    loadStudents()
  }


  useEffect(() => {

    let alternatives = []

    props.institutionOptions?.map((item) => {
      let target = { value: item._id, label: item.name }

      alternatives.push(target)
      
      //verifica se há um institution definida para o grupo
      //e havendo, realiza o carregamento dos demais dados de
      //teacher e students
      if (item._id == props.institution?._id) {
        setValue(target)
        loadTeachers()
        loadStudents()
      }

    })

    setOptions(alternatives)

  }, [props.selectOptions])

  return (
    <div >
      <Select
        className="form-control-alternative"
        isDisabled={props.formDisabled}
        options={options}
        value={value}
        id="input-institution"
        classNamePrefix="selectInstitution"
        onChange={changeHandler}
      />
    </div>
  );

}

export default SelectInstitution;
